import pinia from '@/stores/pinia'

import useRouterStore from '@/stores/router.store'
import useProfileStore from '@/stores/profile.store'
import useUserStore from '@/stores/user.store'
import useSettingsStore from '@/stores/settings.store'
import useChannelStore from '@/stores/channel.store'
import useModeStore from '@/stores/mode.store'
import usePresetRangeStore from '@/stores/presetRange.store'
import usePresetStore from '@/stores/preset.store'
import useRootStore from '@/stores/root.store'
import { checkAuth } from '@/hooks/authentication'
import { Color } from '@nicolaudie-group/ls-utilities'
import dev from '@nicolaudie-group/ng-ui-kit/helpers/dev'

/**
 * Hook called by `main.js` as a Vue plugin, when Vue and all of
 * it's plugins (Vue Router, Pinia...) have been initialized.
 */
export default () => {
  dev.expose({
    Color,
    stores: {
      channels: useChannelStore(pinia),
      modes: useModeStore(pinia),
      presetRanges: usePresetRangeStore(pinia),
      presets: usePresetStore(pinia),
      profile: useProfileStore(pinia),
      root: useRootStore(pinia),
      router: useRouterStore(pinia),
      settings: useSettingsStore(pinia),
      user: useUserStore(pinia),
    },
  })

  // Load needed stores
  const routerStore = useRouterStore(pinia)
  const profileStore = useProfileStore(pinia)

  // Re-load the profile when it's UID changes
  routerStore.onRouteChange((to, from) => profileStore.routeChanged(to, from))

  // Periodically check that the token is still valid
  // Being in an interval, we don't care about the promise result here so no need to await/then
  setInterval(() => {
    checkAuth(routerStore.route)
  }, 10000)
}
